// components/WhatsAppButton.js
import React from 'react';
import './WhatsAppButton.css';

const WhatsAppButton = () => {
  // You can customize the phone number and message
  const phoneNumber = '+265888615918'; // Replace with your phone number
  const message = 'Hello, I am interested in your solar energy solutions. Can you help me?';
  
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  
  return (
    <a 
      href={whatsappUrl} 
      className="whatsapp-float" 
      target="_blank" 
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <i className="fab fa-whatsapp"></i>
    </a>
  );
};

export default WhatsAppButton;